import {
  X,
} from "lucide-react";
import {
  createPortal,
} from "react-dom";
import { SupplierContacts } from "./SupplierContacts";
import { SupplierDocuments } from "./SupplierDocuments";
import { SupplierHistory } from "./SupplierHistory";
import { SupplierOverview } from "./SupplierOverview";
import { SupplierQuality } from "./SupplierQuality";
import type {
  useSuppliersWorkspace,
} from "./useSuppliersWorkspace";

export function SupplierWorkspace({ model }: { model: ReturnType<typeof useSuppliersWorkspace>; }) {
  const {
    setSelectedSupplierId,
    supplierTab,
    setSupplierTab,
    setSupplierAction,
    eligibility,
    selectedSupplier,
    supplierStatusLabels,
    qualificationLabels,
  } = model;
  return (<>
    {selectedSupplier
      ? createPortal(
        <div
          className="supplier-workspace-backdrop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="supplier-workspace-title"
        >
          <section
            className="supplier-workspace"
            aria-label="Tedarikçi yönetimi"
          >
            <header className="supplier-workspace-header">
              <div>
                <span className="section-kicker">
                  Tedarikçi çalışma alanı
                </span>
                <h2 id="supplier-workspace-title">
                  {selectedSupplier.name}
                </h2>
                <p>
                  {selectedSupplier.legalName} ·{" "}
                  {
                    supplierStatusLabels[
                    selectedSupplier.status ?? "ACTIVE"
                    ]
                  }{" "}
                  · Sürüm {selectedSupplier.version ?? 1}
                </p>
              </div>
              <button
                className="icon-button"
                aria-label="Tedarikçi yönetimini kapat"
                onClick={() => setSelectedSupplierId(null)}
              >
                <X size={20} />
              </button>
            </header>
            <div className="supplier-facts" aria-label="Tedarikçi özeti">
              <span>
                <small>Kapsam</small>
                {[
                  ...new Set(
                    selectedSupplier.capabilities
                      ?.map(
                        (item) =>
                          item.productGroupName || item.productGroupCode,
                      )
                      .filter(Boolean),
                  ),
                ].join(", ") || selectedSupplier.category}
              </span>
              <span>
                <small>Risk</small>
                {selectedSupplier.risk}
              </span>
              <span>
                <small>Resmî kalite</small>
                {
                  qualificationLabels[
                  eligibility?.qualificationStatus ?? "NOT_EVALUATED"
                  ]
                }
              </span>
              <span>
                <small>Sonraki adım</small>
                {eligibility?.eligible
                  ? "Satın alma sürecine uygun"
                  : "Kalite kapsamını doğrulayın"}
              </span>
            </div>
            <nav className="supplier-tabs" aria-label="Tedarikçi bölümleri">
              {[
                ["overview", "Genel bakış"],
                ["contacts", "İletişim kişileri"],
                ["quality", "Kalite yeterliliği"],
                ["documents", "Belgeler"],
                ["history", "Geçmiş"],
              ].map(([key, label]) => (
                <button
                  key={key}
                  className={supplierTab === key ? "active" : ""}
                  aria-current={supplierTab === key ? "page" : undefined}
                  onClick={(event) => {
                    setSupplierTab(key as typeof supplierTab);
                    setSupplierAction(null);
                    event.currentTarget.scrollIntoView({
                      behavior: "smooth",
                      block: "nearest",
                      inline: "center",
                    });
                  }}
                >
                  {label}
                </button>
              ))}
            </nav>
            <main className="supplier-workspace-body">
              <SupplierOverview model={model} />
              <SupplierContacts model={model} />
              <SupplierQuality model={model} />
              <SupplierDocuments model={model} />
              <SupplierHistory model={model} />
            </main>
          </section>
        </div>,
        document.body,
      )
      : null}
  </>);
}
